import React from 'react';
import { useParams } from 'react-router-dom';
import Technical from './Technical';
import BreadCrumb from './BreadCrumb';

function TechnicalPage() {
    const { id, plantName } = useParams(); // id is your cogen_id

    return (
        <div className="container-fluid">
            <BreadCrumb />
            <Technical cogen_id={id} plantName={plantName} /> {/* pass as prop */}
        </div>
    );
}

export default TechnicalPage;
